<template>
  <div>
    <div
      v-for="(req, keyP) in allComments"
      :key="keyP"
      style="padding-top: 20px;
          border-bottom: 1px solid rgb(99, 99, 99);
"
    >
      <div v-for="(nane, nameKey) in req.tree" :key="nameKey">
       <b> {{ nane.nom }} - {{ nane.name }}</b>
      </div>
      <div>
        <div v-if="req.indicator" class="col-h4">
          <div class="subTitle">
            {{ $t("label_evaluation_requirementEvaluation_relatedIndicators") }}
          </div>
          {{ $t("label_indicator_" + req.indicator.id + "_acronym") }}-
          {{ $t(req.indicator.name) }}
        </div>
        <div v-if="req.indicator" class="col-h4">
          <div class="subTitle">
            {{ $t("label_evaluation_requirementEvaluation_indicatorValue") }}
          </div>
          <span class="valueTag" :class="'barReport-' + req.indicator.color">{{
            getIndicatorValue(req)
          }}</span>
        </div>
        <div v-if="req.indicator" class="col-h4">
          <div class="subTitle" style="margin-top: -15px">
            {{ $t("label_evaluation_report_performanceMeasure") }}
          </div>
          <div style="position: relative; width: 50%; margin-left: 30px">
            <div class="barReport">
              <section
                v-for="(barReport, barReportKey) in req.indicator.barReports"
                :key="barReportKey"
                :style="{
                  width:
                    toEquivalentPercentage(
                      req.indicator.range,
                      barReport.final
                    ) -
                    toEquivalentPercentage(
                      req.indicator.range,
                      barReport.initial
                    ) +
                    '%',
                }"
                :class="'barReport-' + barReport.color"
              />
            </div>
            <img
              src="/static/images/icon_indicator.svg"
              width="30"
              style="position: absolute; top: 0"
              :style="{
                left:
                  'calc(' +
                  toEquivalentPercentage(
                    req.indicator.range,
                    req.indicator.value
                  ) +
                  '% - 15px)',
              }"
            />
            <img
              v-for="(ideal, idealKey) in req.indicator.ideals"
              :key="idealKey"
              src="/static/images/icon_ideal_value.svg"
              width="30"
              style="position: absolute; top: 0"
              :style="{
                left:
                  'calc(' +
                  toEquivalentPercentage(req.indicator.range, ideal) +
                  '% - 15px)',
              }"
            />
            <div
              style="display: flex; justify-content: space-between; width: 101%"
            >
              <div
                v-for="(tick, tickKey) in req.indicator.rangeArr"
                :key="tickKey"
              >
                {{ tick.toFixed(2) }}
              </div>
            </div>
          </div>
        </div>

        <div
          v-for="(comme, index) of req.comment"
          :key="index"
          class="commentContainer"
        >
          <div class="commentContext">
            <span v-if="comme.account"
              >{{ comme.account.account.name }}
              {{ comme.account.account.lastName }}</span
            >
            - <span v-if="comme.category">{{ $t(comme.category) }} </span> -
            <span v-if="comme.date">({{ comme.date }}): </span>
          </div>
          <div class="commentText">
            {{ comme.comment }}
          </div>
        </div>
      </div>

    </div>
  </div>
</template>
<script >
export default {
  name: "EvaluationReportComments",
  props: {
    tree: {
      type: Object,
      default: () => {},
    },
  },
  data: function () {
    return {
      allComments: [],
    };
  },
  watch: {
    tree: {
      handler: function () {
        this.allComments = [];
        this.extractComments(this.tree, []);
      },
      deep: true,
    },
  },
  mounted() {
    this.allComments = [];
    this.extractComments(this.tree, []);
  },
  methods: {
    getIndicatorValue(req) {
      if (isNaN(req.indicator.value)) {
        return req.indicator.value;
      } else {
        return Number(req.indicator.value).toFixed(2);
      }
    },
    setToValue(obj, path, value, array = true) {
      var i;
      path = path.split(".");
      for (i = 0; i < path.length - 1; i++) {
        if (typeof obj[path[i]] === "undefined") {
          obj[path[i]] = {};
        }
        obj = obj[path[i]];
      }
      if (array) {
        if (typeof obj[path[i]] === "undefined") {
          obj[path[i]] = [];
        }
        obj[path[i]].push(value);
      } else {
        obj[path[i]] = value;
      }
    },
    extractComments(node, deepTree) {
      if (node.children && node.children.length > 0) {
        if (node.evaluation_administrator_node_requirementName) {
          deepTree.push({
            nom: node.evaluation_administrator_node_nomenclature,
            name: node.evaluation_administrator_node_requirementName,
          });
        }
        node.children.map((child) => this.extractComments(child, []));
      } else {
        if (node.evaluation_administrator_node_matrix_indicator_indicator) {
          const barReports = [];
          if (
            node.evaluation_administrator_node_matrix_indicator_indicator.ranges
              .negMin1 !== null &&
            node.evaluation_administrator_node_matrix_indicator_indicator.ranges
              .negMax1 !== null
          ) {
            barReports.push({
              initial: isFinite(
                node.evaluation_administrator_node_matrix_indicator_indicator
                  .ranges.negMin1
              )
                ? node.evaluation_administrator_node_matrix_indicator_indicator
                    .ranges.negMin1
                : node.evaluation_administrator_node_matrix_indicator_indicator
                    .ranges.negMax1 * 1.2,
              final:
                node.evaluation_administrator_node_matrix_indicator_indicator
                  .ranges.negMax1,
              color: "red",
            });
          }

          if (
            node.evaluation_administrator_node_matrix_indicator_indicator.ranges
              .interMin1 !== null &&
            node.evaluation_administrator_node_matrix_indicator_indicator.ranges
              .interMax1 !== null
          ) {
            barReports.push({
              initial:
                node.evaluation_administrator_node_matrix_indicator_indicator
                  .ranges.interMin1,
              final:
                node.evaluation_administrator_node_matrix_indicator_indicator
                  .ranges.interMax1,
              color: "yellow",
            });
          }
          if (
            node.evaluation_administrator_node_matrix_indicator_indicator.ranges
              .posMin1 !== null &&
            node.evaluation_administrator_node_matrix_indicator_indicator.ranges
              .posMax1 !== null
          ) {
            barReports.push({
              initial:
                node.evaluation_administrator_node_matrix_indicator_indicator
                  .ranges.posMin1,
              final:
                node.evaluation_administrator_node_matrix_indicator_indicator
                  .ranges.posMax1,
              color: "green",
            });
          }
          if (
            node.evaluation_administrator_node_matrix_indicator_indicator.ranges
              .interMin2 !== null &&
            node.evaluation_administrator_node_matrix_indicator_indicator.ranges
              .interMax2 !== null
          ) {
            barReports.push({
              initial:
                node.evaluation_administrator_node_matrix_indicator_indicator
                  .ranges.interMin2,
              final:
                node.evaluation_administrator_node_matrix_indicator_indicator
                  .ranges.interMax2,
              color: "yellow",
            });
          }

          if (
            node.evaluation_administrator_node_matrix_indicator_indicator.ranges
              .negMin2 !== null &&
            node.evaluation_administrator_node_matrix_indicator_indicator.ranges
              .negMax2 !== null
          ) {
            barReports.push({
              initial:
                node.evaluation_administrator_node_matrix_indicator_indicator
                  .ranges.negMin2,
              final: isFinite(
                node.evaluation_administrator_node_matrix_indicator_indicator
                  .ranges.negMax2
              )
                ? Math.ceil(
                    node
                      .evaluation_administrator_node_matrix_indicator_indicator
                      .ranges.negMax2
                  )
                : Math.ceil(
                    node
                      .evaluation_administrator_node_matrix_indicator_indicator
                      .ranges.negMin2 * 1.2
                  ),
              color: "red",
            });
          }

          barReports.sort((a, b) => {
            if (a.initial > b.initial) {
              return 1;
            }
            if (b.initial > a.initial) {
              return -1;
            }

            return 0;
          });
          const range = {
            start: barReports[0].initial,
            end: Math.ceil(barReports[barReports.length - 1].final),
          };
          const rangeArr = [];
          const distance = Math.abs(range.start - range.end);
          for (let i = 0; i < 5; i++) {
            rangeArr.push(range.start + i * (distance / 5));
          }
          barReports.map((barReport) => {
            if (
              barReport.initial <=
                node.evaluation_administrator_node_matrix_indicator_indicator
                  .value &&
              barReport.final >=
                node.evaluation_administrator_node_matrix_indicator_indicator
                  .value
            ) {
              node.evaluation_administrator_node_matrix_indicator_indicator.color =
                barReport.color;
            }
          });
          rangeArr.push(range.end);
          node.evaluation_administrator_node_matrix_indicator_indicator.barReports =
            barReports;
          node.evaluation_administrator_node_matrix_indicator_indicator.rangeArr =
            rangeArr;
          node.evaluation_administrator_node_matrix_indicator_indicator.range =
            range;

          /*            this.setToValue(this.allComments,
             path + node.evaluation_administrator_node_matrix_indicator_indicator.id + '.indicator',
             node.evaluation_administrator_node_matrix_indicator_indicator, false)
             path += node.evaluation_administrator_node_matrix_indicator_indicator.id + '.comments'
             if (node.comments && node.comments.length > 0) {
             node.comments.map(comment => {
             this.setToValue(this.allComments, path,
             comment)
             })
             }*/
        }
        const visibleComments = (node.comments || []).filter(
          (comment) =>
            comment.scope ===
            "label_evaluation_requirementEvaluation_post_includeInFinalReport"
        );
        if (visibleComments.length > 0) {
          this.allComments.push({
            comment: visibleComments,
            indicator:
              node.evaluation_administrator_node_matrix_indicator_indicator,
            tree: [
              ...deepTree,
              {
                nom: node.evaluation_administrator_node_nomenclature,
                name: node.evaluation_administrator_node_requirementName,
              },
            ],
          });
        }
      }
    },
    toEquivalentPercentage(range, value) {
      const distance = Math.abs(range.start - range.end);
      const eq = ((value - range.start) * 100) / distance;
      return eq;
    },
  },
};
</script >
<style lang="scss" scoped>
.container {
  padding-top: 30px;
  padding-bottom: 30px;
  border-bottom: 1px solid #636363;
}
</style>
<style lang="scss" >
h4 {
  font-size: 1.3rem;
  text-transform: uppercase;
}

.barReport {
  height: 30px;
  width: 100%;
  margin: 0 auto;
  display: flex;
  overflow: hidden;
}

.barReport section {
  height: 30px;
  line-height: 30px;
  text-align: center;
  color: white;
}

.barReport-red {
  background: rgb(230, 2, 70);
  color: #ffffff;
}

.barReport-yellow {
  background: rgb(255, 190, 0);
  color: #000000;
}

.barReport-green {
  background: rgb(0, 147, 85);
  color: #ffffff;
}

.valueTag {
  align-self: center;
  margin-left: 23px;
  padding: 5px 8px;
  font-weight: bold;
  border-radius: 7px;
}

.subTitle {
  font-size: 1.1rem;
  font-weight: bold;
  text-transform: uppercase;
  padding-right: 10px;
  font-family: 'Montserrat-Bold';
}

.col-h4 {
  display: flex;
  align-items: center;
  margin: 20px 0;
}

.commentText {
  padding: 0px 0px 10px;
  text-align: justify;
  margin-left: 30px;

}

.commentContext {
  font-weight: bold;
  margin-left: 30px;
}
.commentContainer{
  margin-top: 20px;

}
</style >
